import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarVeiculosDs,
  criarTiposVeiculosDs,
} from "../../DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import sysCodigoDescricao from "../../components/sysCodigoDescricao";
import ContribuinteBox from "../contribuintes/ContribuinteBox";
import { criarContribuinteDs } from "../../DataSources";
import { Button, ScrollView } from "devextreme-react";
import Memoria from "../../Memoria";
import ShowError from "../../AppServices";

const _versaoCadastro = 1;
let _cadastroCorrente = undefined;
let _cancelando = false;

const template = {
  id: undefined,
  prefeituraId: undefined,
  contribuinteId: undefined,
  placa: "",
  anoFabricacao: undefined,
  anoModelo: undefined,
  marca: "",
  modelo: "",
  cor: "",
  chassi: "",
  renavam: "",
  tipoDeVeiculoId: undefined,
  atividade: "",
  obs: "",
  descricaoCompleta: "",
  anoFabricaEModelo: "",
  popupVisivel: false,
};

export default class VeiculoForm extends React.Component {
  constructor(props) {
    super(props);
    console.log(this);
    this.veiculoDs = criarVeiculosDs();
    this.contribuinteDs = criarContribuinteDs();
    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
    template.prefeituraId = UserInfo.getPrefeitura();
    this.state = { ...(_cadastroCorrente || template) };
    this.setContribuinteId = this.setContribuinteId.bind(this);
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.pesquisarContribuinte = this.pesquisarContribuinte.bind(this);
    this.onContribuinteSelecionadoPesquisa =
      this.onContribuinteSelecionadoPesquisa.bind(this);
    this.contribuinteBoxRef = React.createRef();
    this.renderContribuinte = sysCodigoDescricao(
      () => this.state.contribuinteId,
      this.setContribuinteId,
      () => this.state._uiNomeContribuinte,
      this.pesquisarContribuinte
    );
    this.setNomeContribuinte = this.setNomeContribuinte.bind(this);
    this.atualizarNomeContribuinte = this.atualizarNomeContribuinte.bind(this);
  }

  setContribuinteId(data) {
    this.setState({ contribuinteId: data.value });
    this.atualizarNomeContribuinte();
  }

  atualizarNomeContribuinte() {
    this.contribuinteDs
      .load({ filter: [["sequencial", "=", this.state.contribuinteId]] })
      .then((result) => {
        console.log(result);
        if (result.length !== 0) {
          this.setNomeContribuinte(result[0]);
        } else {
          this.setNomeContribuinte(undefined);
        }
      })
      .catch((_) => this.setNomeContribuinteErro());
  }

  setNomeContribuinte(contribuinte) {
    if (contribuinte === undefined) {
      this.setState({ _uiNomeContribuinte: "" });
    } else {
      this.setState({ _uiNomeContribuinte: contribuinte.nome });
    }
  }

  setNomeContribuinteErro() {
    this.setState({ _uiNomeContribuinte: "<<ERRO>>" });
  }

  onContribuinteSelecionadoPesquisa(e) {
    this.setState({
      contribuinteId: e.row.data.sequencial,
      popupVisivel: false,
    });
    this.atualizarNomeContribuinte();
  }

  pesquisarContribuinte() {
    this.contribuinteBoxRef.current.limparFiltro();
    this.setState({ popupVisivel: true });
  }

  componentDidMount() {
    _cadastroCorrente = Memoria.resturarEstado(
      this.props.location,
      _cadastroCorrente,
      _versaoCadastro
    );

    if (_cadastroCorrente === undefined) {
      if (this.props.match.params.id !== undefined) {
        this.veiculoDs
          .byKey(this.props.match.params.id)
          .then((data) => {
            if (data === undefined) {
              notify("Registro não encontrado.", "error");
              this.props.history.push("/veiculo");
            }
            console.log("contribuinte", data);
            this.setState({
              ...data,
              contribuinteId: data.contribuinte.sequencial,
            });
            this.atualizarNomeContribuinte();
          })
          .catch((error) => {
            ShowError(error.response.data);
            notify(error, "error", 2000);
            this.props.history.goBack();
          });
      } else {
        this.setState({ ...template });
      }
    } else {
      this.setState({ ..._cadastroCorrente });
    }
    _cancelando = false;
  }

  componentWillUnmount() {
    _cadastroCorrente = _cancelando ? undefined : this.state;
    if (_cadastroCorrente != undefined) {
      Memoria.emEdicao(this.props.location, _cadastroCorrente, _versaoCadastro);
    }
  }

  render() {
    const tipoVeiculosOptions = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: criarTiposVeiculosDs(),
      valueExpr: "id",
      displayExpr: "descricao",
    };

    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <Form formData={this.state} colCount={2}>
              <GroupItem
                caption="INFORMAÇÕES DO VEÍCULO"
                colSpan={2}
                colCount={4}
              >
                <SimpleItem
                  dataField={"tipoDeVeiculoId"}
                  editorType={"dxLookup"}
                  editorOptions={tipoVeiculosOptions}
                  colSpan={4}
                >
                  <Label text="Tipo de Veículo" />
                </SimpleItem>
                <SimpleItem colSpan={4} component={this.renderContribuinte}>
                  <Label text="Contribuinte" />
                </SimpleItem>
                <SimpleItem dataField={"placa"} colSpan={2}>
                  <Label text="Placa" />
                </SimpleItem>
                <SimpleItem dataField={"renavam"} colSpan={2}>
                  <Label text="Renavam" />
                </SimpleItem>
                <SimpleItem dataField={"chassi"} colSpan={4}>
                  <Label text="Chassi" />
                </SimpleItem>
                <SimpleItem dataField={"anoFabricacao"}>
                  <Label text="Ano de Fabricação" />
                </SimpleItem>
                <SimpleItem dataField={"anoModelo"}>
                  <Label text="Ano do Modelo" />
                </SimpleItem>
                <SimpleItem dataField={"marca"} colSpan={2}>
                  <Label text="Marca" />
                </SimpleItem>
                <SimpleItem dataField={"modelo"} colSpan={2}>
                  <Label text="Modelo" />
                </SimpleItem>
                <SimpleItem dataField={"cor"} colSpan={2}>
                  <Label text="Cor" />
                </SimpleItem>
                <SimpleItem
                  dataField={"atividade"}
                  colSpan={4}
                  editorType="dxTextArea"
                  editorOptions={{ height: 90 }}
                >
                  <Label text="Atividade" />
                </SimpleItem>
                <SimpleItem
                  dataField={"obs"}
                  colSpan={4}
                  editorType="dxTextArea"
                  editorOptions={{ height: 90 }}
                >
                  <Label text="Observações" />
                </SimpleItem>
              </GroupItem>
            </Form>
            <div style={{ marginTop: "10px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  width={120}
                  text="Salvar"
                  type="success"
                  onClick={this.ok}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button text="Cancelar" onClick={this.cancel} />
              </div>
            </div>
          </form>
          <Popup
            visible={this.state.popupVisivel}
            onHiding={this.hideInfo}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showCloseButton={false}
            showTitle={true}
            width={"90%"}
            height={"90%"}
            title="Pesquisar Contribuinte"
          >
            <ScrollView showScrollbar={"always"}>
              <ContribuinteBox
                onSelecionado={this.onContribuinteSelecionadoPesquisa}
                ref={this.contribuinteBoxRef}
              />
            </ScrollView>
            <ToolbarItem
              toolbar={"bottom"}
              widget="dxButton"
              location="center"
              options={{
                text: "Fechar",
                type: "default",
                width: 150,
                onClick: () => this.setState({ popupVisivel: false }),
              }}
            ></ToolbarItem>
          </Popup>
        </div>
      </React.Fragment>
    );
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.veiculoDs, entidade)
      .then(
        function () {
          notify("Veículo cadastrado com sucesso.", "success");
          _cadastroCorrente = undefined;
          _cancelando = true;
          Memoria.removerEdicao(this.props.location);
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    _cadastroCorrente = undefined;
    _cancelando = true;
    notify("Operação cancelada", "warning");
    Memoria.removerEdicao(this.props.location);
    this.props.history.goBack();
  }
}
